<template>
  <div
    class="Card"
    :class="{
      'Card--published': (typeof published === 'boolean' ? published : true) || etat === 'V',
      'Card--fullWidth': fullWidth,
      'Card--noHeader': !title && !$slots.header
    }"
  >
    <div class="Card-header" v-if="title || $slots.header">
      <!-- @slot Entête checkbox -->
      <slot name="headerCheckbox">
        <div v-if="label" class="Card-headerCheckbox">
          <el-checkbox :value="value" @input="$emit('input', $event)" :label="label">
            <em></em>
          </el-checkbox>
        </div>
      </slot>
      <div class="Card-headerContent">
        <!-- @slot Entête de la carte -->
        <slot name="header">
          <h3>{{ title }}</h3>
        </slot>
      </div>
    </div>
    <div class="Card-main">
      <el-tags-posts :size="size" :typeObjet="typeObjet" :typeOffre="typeOffre" :annonce-parente="annonceParente" class="Card-tag" v-if="isBailleurSocial"></el-tags-posts>
      <span  v-if="saisieFlux">
          <el-tooltip class="item" effect="dark" :content="$t('components.card.postFlux')" placement="top-start">
            <div
              v-if="etat != null && etat != 'M' && etat != 'V' && etat != 'S'"
              class="Card-published"
              @click="updateEtatPost"
              >
              <span v-if="etat == 'A'">{{ $t("components.card.activated") }}</span>
              <span v-else>{{ $t("components.card.deactivated") }}</span>
              <el-switch :value="published" active-color="#25a78d" :disabled="true"/>
            </div>
          </el-tooltip>
        </span>
        <span v-else>
            <div
                    v-if="etat != null && etat != 'M' && etat != 'V' && etat != 'S'"
                    class="Card-published"
                    @click="updateEtatPost"
            >
              <span v-if="etat == 'A'">{{ $t("components.card.activated") }}</span>
              <span v-else>{{ $t("components.card.draft") }}</span>
              <el-switch :value="published" active-color="#25a78d"/>
            </div>
        </span>
      <div v-if="isBailleurSocial">
        <div v-if="etat === 'S'" class="Card--supprime bailleur">Supprimé</div>
        <div v-if="etat === 'M'" class="Card--modele bailleur">Modèle</div>
        <div v-if="etat === 'V'" class="Card--vendu bailleur">Vendu</div>
      </div>
      <div v-else>
        <div v-if="etat === 'S'" class="Card--supprime">Supprimé</div>
        <div  v-if="etat === 'M' && isCmi" class="property-tag Card--modele--cmi" :class="getTagClass(typeObjet)">
          {{ getTagLabel(typeObjet) }}
        </div>
        <div v-if="etat === 'M' && !isCmi" class="Card--modele">Modèle</div>
        <div v-if="etat === 'V'" class="Card--vendu">Vendu</div>
      </div>
      <div v-if="(nbPortailsActifs > 0) && (nbDiffusions > 0) && getAdvertisers.includes(advertiser.id)">
        <div class="Card--valide">Validée</div>
      </div>

      <slot></slot>
    </div>
    <div
      class="Card-footer"
      v-if="$slots.footer"
      :class="{ 'Card-footer--touch': browserContext.hasTouch }"
    >
      <!-- @slot Pied-de-page / actions de la carte -->
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import TagsPosts from '../pages/posts/components/TagsPosts'
import { mapGetters } from 'vuex'

/**
 * Carte pour affichage en grille ou mobile
 */
export default {
  name: 'UbiCard',
  components: {
    ElTagsPosts: TagsPosts
  },
  inject: ['browserContext'],
  props: {
    value: { type: Array, default: () => [] },
    label: String,
    etat: String,
    sourceCode: String,
    id: String,
    title: String,
    published: { type: Boolean, default: null },
    fullWidth: { type: Boolean, default: false },
    typeObjet: Number,
    typeOffre: String,
    annonceParente: String,
    nbDiffusions: String,
    nbPortailsActifs: Number,
    advertiser: Object
  },
  data () {
    return {
      size: 'medium'
    }
  },
  computed: {
    ...mapGetters('lamotte', ['getAdvertisers']),
    ...mapGetters(['isCmi']),
    saisieFlux () {
      return !(this.sourceCode === 'SAISIE_IMMO' || this.sourceCode === 'SAISIE_VO')
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    }
  },
  methods: {
    getTagLabel (typeObjet) {
      const codeMap = {
        // Terrains
        1310: 'Terrain',
        1300: 'Terrain',
        1350: 'Terrain',
        // Programmes
        1340: 'Programme',
        3000: 'Programme',
        3100: 'Programme',
        3200: 'Programme',
        3400: 'Programme',
        5000: 'Programme',
        5200: 'Programme',
        // Lots
        4000: 'Lot',
        4100: 'Lot',
        4200: 'Lot',
        4300: 'Lot',
        4400: 'Lot',
        // Maison
        1200: 'Maison'
      }
      return codeMap[typeObjet] || 'Modèles'
    },
    getTagClass (typeObjet) {
      const code = parseInt(typeObjet)

      if ([1310, 1300, 1350].includes(code)) {
        return 'tag--terrain'
      }
      if ([1340, 3000, 3100, 3200, 3400, 5000, 5200].includes(code)) {
        return 'tag--programme'
      }
      if ([4000, 4100, 4200, 4300, 4400].includes(code)) {
        return 'tag--lot'
      }
      if (code === 1200) {
        return 'tag--maison'
      }
      return 'tag--default'
    },
    updateEtatPost () {
      if (!this.saisieFlux) {
        this.$emit('update:published')
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

$card-padding: map-get($spacers, 5) / 2;

.Card {
  background: $yellow-pastel;
  margin-left: -$card-padding;
  margin-right: -$card-padding;
  padding: $card-padding;
  position: relative;
  overflow: hidden;
  z-index: 1;

  &-header {
    max-height: 106px;
    @extend .mb-0;
    border-bottom: 2px solid $white;
    display: flex;
    margin: -$card-padding;
    padding: $card-padding;

    h3 {
      text-transform: initial;
      line-height: 20px;
    }
  }

  &-headerContent {
    flex: 1;
  }

  &-main {
    @extend .p-3;
    margin-left: -$card-padding;
    margin-right: -$card-padding;
    margin-bottom: -$card-padding;
    position: relative;

    > img {
      width: 100%;
      object-fit: cover;
      filter: sepia(80%);
      opacity: 0.5;
    }

    .Card--published & {
      > img {
        filter: none;
        opacity: 1;
      }
    }
  }

  &--noHeader {
    .Card-main {
      margin-top: -$card-padding;
    }
  }

  &--small {
    .Card-main img {
      height: 215px;
    }
  }

  &-published {
    @extend .py-2, .pl-3, .pr-2;
    align-items: center;
    background: $gray-100;
    border-radius: 35px;
    cursor: pointer;
    display: flex;
    height: 35px;
    position: absolute;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
    z-index: 1;

    & > :not(:last-child) {
      @extend .mr-2;
    }
  }

  &-tag {
    @extend .py-2, .pl-3, .pr-2;
    align-items: center;
    //background: $gray-100;
    border-radius: 35px;
    cursor: pointer;
    display: flex;
    height: 35px;
    position: absolute;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
    z-index: 1;
    margin-top: 40px;

    & > :not(:last-child) {
      @extend .mr-2;
    }
  }

  &-footer {
    padding: $card-padding;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    z-index: 1;
    background: rgba($blue-pastel, 0.9);
    transform: translateY(100%);
    transition: transform 0.3s;
  }

  &:hover .Card-footer,
  .Card-footer--touch {
    transform: translateY(0%);
  }

  .Card--supprime {
    position: absolute;
    z-index: 2; /* place .boite-verte au-dessus de .boite-tirets */
    background: #255662;
    width: 28%;
    height: 35px;
    border-radius: 35px;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
    color:white;
    /*font-size: large;*/
    //height: 7em;
    opacity: 1;
    text-align: center;
    padding-top: 7px;
  }

  .Card--modele {
    position: absolute;
    z-index: 2; /* place .boite-verte au-dessus de .boite-tirets */
    background: #21B1BE;
    width: 28%;
    height: 35px;
    border-radius: 35px;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
    color:white;
    /*font-size: large;*/
    //height: 7em;
    opacity: 1;
    text-align: center;
    padding-top: 7px;
  }

  .Card--modele--cmi {
    position: absolute;
    z-index: 2; /* place .boite-verte au-dessus de .boite-tirets */
    width: 28%;
    height: 35px;
    border-radius: 35px;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
    color:white;
    /*font-size: large;*/
    //height: 7em;
    opacity: 1;
    text-align: center;
    padding-top: 7px;
  }

  .Card--vendu {
    position: absolute;
    z-index: 2; /* place .boite-verte au-dessus de .boite-tirets */
    background: #D35B68;
    width: 28%;
    height: 35px;
    border-radius: 35px;
    right: map-get($spacers, 3);
    top: map-get($spacers, 3);
    color:white;
    /*font-size: large;*/
    //height: 7em;
    opacity: 1;
    text-align: center;
    padding-top: 7px;
  }

  .Card--valide {
    position: absolute;
    z-index: 2;
    background: #79c8b9;
    width: 13%;
    height: 35px;
    border-radius: 35px;
    left: map-get($spacers, 3);
    top: map-get($spacers, 3);
    color:white;
    opacity: 1;
    text-align: center;
    padding-top: 7px;
  }

  .bailleur {
    top: 16%;
  }

  &--fullWidth {
    .Card-main {
      padding: 0 !important;
    }
  }

  @include media-breakpoint-down(md) {
    background: $white;
    margin: 0;
    border: 1px solid $gray-300;

    &-main {
      background: $yellow-pastel;
    }
  }

  /* Style pour les terrains */
  .tag--terrain {
    background-color: #FFC107;
  }

  /* Style pour les programmes */
  .tag--programme {
    background-color: #194A58;
  }

  /* Style pour les lots */
  .tag--lot {
    background-color: #92C2D7;
  }

  /* Style pour les maisons */
  .tag--maison {
    background-color: #F0921E;
  }

  /* Style par défaut */
  .tag--default {
    background-color: #0AB1BF;
  }
}
</style>
